import { Box, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { F0TagRaw } from '@factorialco/f0-react'
import { Link } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

export interface CompetencyTagProps {
  name: string
  isInherited: boolean
  inheritedFromName?: string
}

const CompetencyTag = ({ name, isInherited, inheritedFromName }: CompetencyTagProps) => {
  const [tooltipOpen, toggleTooltip] = useToggle(false)
  const tag = <F0TagRaw text={name} icon={isInherited ? Link : undefined} />

  if (isInherited) {
    return (
      <Tooltip.Alt
        attachment="top center"
        targetAttachment="bottom center"
        open={tooltipOpen}
        toggle={toggleTooltip}
        label={i18n.t('job_catalog.nodes.competency.inherited_from', {
          nodeName: inheritedFromName ?? i18n.t('job_catalog.nodes.working_conditions.parent_node'),
        })}
      >
        <Box
          onMouseEnter={toggleTooltip(true)}
          onMouseLeave={toggleTooltip(false)}
          style={{ display: 'inline-flex', cursor: 'default' }}
        >
          {tag}
        </Box>
      </Tooltip.Alt>
    )
  }

  return tag
}

export default CompetencyTag
